RivalIQ.apps.SocialPosts.module('views', function (views, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    views.HistoryLimit = RivalIQ.views.ItemView.extend({

        ui: {
            contactUsBtn: '.x-contact-us'
        },

        events: {
            'click @ui.contactUsBtn': 'onContactUsClick'
        },

        template: '#historyLimitTemplate',

        templateHelpers: function () {

            const allowedHistoryDays = RivalIQ.state.account.get('historyLimits').mainPeriod;
            const approximateMonthsAllowed = Math.floor(allowedHistoryDays / 31);
            const startAfterDate = moment.utc().subtract(allowedHistoryDays, 'days').startOf('day').add(1, 'day').format('LL');

            const isAnnual = RivalIQ.state.account.get('plan').annual;

            return {
                startAfterDate: startAfterDate,
                approximateMonthsAllowed: approximateMonthsAllowed,
                isAnnual: isAnnual
            };
        },


        onContactUsClick: function () {

            RivalIQ.execute('show:modal', new RivalIQ.apps.Shell.views.ContactUsModal({
                model: new Backbone.Model({
                    context: 'social posts'
                })
            }));
        }

    });

}, window.moment);
